import API_CONFIG from "../config/api";

export interface StoreSource { id: number; name: string; status?: string; priority?: number }
export interface ConfigStore {
  id: number; company_id: number; warehouse_id: number; warehouse_name: string;
  store_name: string; store_slug: string; store_description: string; domain: string; logo_url: string;
  is_active: boolean; created_at: string; warehouse_ids: number[]; source_warehouses: StoreSource[];
}
export interface StoreWarehouse { id: number; company_id: number; name: string }
export const optionalStoreText = (value: unknown) => {
  const text = String(value ?? "").trim();
  return ["null", "undefined"].includes(text.toLowerCase()) ? "" : text;
};
export const storeEnabled = (value: unknown) => value === true || value === 1 || value === "1";
export const normalizeConfigStore = (row: any): ConfigStore => ({ ...row,
  id: Number(row.id), company_id: Number(row.company_id), warehouse_id: Number(row.warehouse_id),
  store_description: optionalStoreText(row.store_description), domain: optionalStoreText(row.domain),
  logo_url: optionalStoreText(row.logo_url), is_active: storeEnabled(row.is_active),
  warehouse_ids: Array.isArray(row.warehouse_ids) ? row.warehouse_ids.map(Number) : [Number(row.warehouse_id)],
  source_warehouses: Array.isArray(row.source_warehouses) ? row.source_warehouses.map((source: any) => ({ ...source, id: Number(source.id) })) : [],
});
export const configStoreUrl = (store: ConfigStore) => API_CONFIG.getStoreMetaUrl(store.store_slug, store.logo_url, store.domain,
  `${store.store_name}:${store.store_description || ""}`);
export const storeLogoUrl = (url: string) => /^(https?:|blob:|data:)/i.test(url) ? url : API_CONFIG.url(url.startsWith("/") ? url : `/${url}`);
export const configStoreFingerprint = (store: ConfigStore) => JSON.stringify([
  store.id, store.company_id, store.warehouse_id, store.store_name, store.store_slug,
  store.store_description, store.domain, store.logo_url, store.is_active, store.warehouse_ids,
]);
export const storeSlug = (name: string) => name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
export const configStoreValues = (store: ConfigStore) => ({ store_name: store.store_name, store_slug: store.store_slug,
  store_description: store.store_description, domain: store.domain, is_active: store.is_active,
  warehouse_id: store.warehouse_id, warehouse_ids: store.warehouse_ids,
  logo: store.logo_url ? [{ uid: `store-${store.id}`, name: "Logo enregistré", status: "done", url: storeLogoUrl(store.logo_url) }] : [],
});
export const buildConfigStoreBody = (values: any, warehouseId: number, creating: boolean, canChangeStatus: boolean) => {
  const body = new FormData();
  body.append("store_name", values.store_name.trim());
  body.append("store_description", optionalStoreText(values.store_description));
  body.append("domain", optionalStoreText(values.domain));
  body.append("warehouse_id", String(warehouseId));
  body.append("warehouse_ids", JSON.stringify(values.warehouse_ids.map(Number)));
  // Le serveur fixe l'identifiant public à la création ; il ne le modifie pas en PUT.
  if (creating) body.append("store_slug", values.store_slug.trim());
  if (creating || canChangeStatus) body.append("is_active", values.is_active ? "1" : "0");
  const logo = values.logo?.[0]?.originFileObj;
  if (logo instanceof Blob) body.append("logo", logo);
  return body;
};
export const storeRequestError = (error: any, fallback: string) => error?.response?.data?.error || error?.response?.data?.message || fallback;
